<script setup>
defineProps({
    member: {
        type: Object,
        default: () => ({}),
    },
    premium: {
        type: Boolean,
        default: false,
    },
})
</script>

<template>
    <span :class="['nav-avatar', { 'nav-avatar-premium': premium }]">
        <BaseResourceImage
            v-if="member?.avatar?.url"
            class="nav-avatar-image"
            :resource="member"
            :should-lazyload="false"
            :fill="false"
            :centered="true"
            type="avatar"
        />
        <BaseIcon
            v-else
            class="nav-avatar-glyph"
            name="user"
            :size="20"
        />
    </span>
</template>

<style lang="scss" scoped>
@use '@design' as *;

$avatar: 36px;
$ring: 2.5px;

.nav-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    color: $c-text-primary;
    background: $c-surface-raised;
    border: $ring solid transparent;
    border-radius: $radius-full;

    @include square($avatar);
}

// Subscribers: flat accent ring, 2.5px (T10 — the crown retires).
.nav-avatar-premium {
    border-color: $c-accent-default;
}

.nav-avatar-image {
    width: 100%;
    height: 100%;
}
</style>
